import notification from 'ant-design-vue/es/notification'
/**
 * http通用处理逻辑
 * @param option {object}
 * @returns {}
 **/

export class HttpHandlerService {
  // 检查code并给出操作成功提示
  checkCode (result, showMsg, msgTitle, msgText) {
    if (result?.code === 0) {
      if (!showMsg || showMsg === null || showMsg === true) {
        notification.success({
          message: msgTitle || '操作成功',
          description: msgText || msgTitle || `操作成功`
        })
      }
      return true
    } else {
      if (result.msg) {
        notification.error({
          message: '失败',
          description: result.msg
        })
      }
      return false
    }
  }
}
